import * as React from 'react';

import type { DisplayViewEmployeeViewModel } from 'ab-viewModels/scheduleBoardDisplayView.viewModel';
import type ScheduleBoardEmployeeViewModel from 'ab-viewModels/scheduleBoardEmployee.viewModel';

import { CDLStatus } from '@acceligentllc/shared/enums/cdlStatus';

import * as ColorUtils from 'af-utils/color.util';

import EmployeeAdditionalInfo from './EmployeeAdditionalInfo';
import { getDisplayData } from '../../../Shared/EmployeeDraggable/helpers';

interface OwnProps {
	employee: DisplayViewEmployeeViewModel;
}

type Props = OwnProps;

const UnavailableEmployeeItem: React.FC<Props> = (props: Props) => {
	const { employee } = props;
	const { unavailabilityReason, returnDate, officeColor, cdlStatus } = employee;
	const { firstName, lastName } = getDisplayData(employee as unknown as ScheduleBoardEmployeeViewModel);

	return (
		<div className="display-view__unavailable-item">
			<div className="display-view__card-and-date">
				<div className={`sb-resource-item sb-resource-item--employee ${cdlStatus === CDLStatus.NO_CDL ? 'sb-resource-item--no-cdl' : ''}`}>
					<div className="sb-resource-item__content">
						<span className={`sb-resource-item__full-name ${ColorUtils.getColorTextClass(officeColor, true)}`}>
							{firstName} <span className="sb-resource-item__last-name">{lastName}</span>
						</span>
						<EmployeeAdditionalInfo employee={employee} />
					</div>
				</div>
				<span className="display-view__card-and-date__date">{returnDate}</span>
			</div>
			<span className="display-view__card-and-date__reason">{unavailabilityReason}</span>
		</div>
	);
};

export default React.memo(UnavailableEmployeeItem);
